//kurikitに表示するBlockの設定

const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const log = require('../../util/log');
const formatMessage = require('format-message');
const KokoroPro = require('./wrapper');
const locate = require('./locate');

const blockIconURI = 'data:image/svg+xml;base64,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';
const menuIconURI = 'data:image/svg+xml;base64,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';
const AvailableLocales = ['en', 'ja', 'ja-Hira'];
const Message = locate.msg;
const ConnectionState = {
    NONE: 'none',
    NOT_FOUND: 'notfound',
    TRY: 'connecting',
    CONNECTED: 'connected',
    DISCONNECTING: 'disconnecting',
    LOST: 'lost'
}

class KonashiBlocks {
    constructor(runtime) {
        this._runtime = runtime;

        this._kokoroPro = new KokoroPro();
        this._connectionState = ConnectionState.NONE;
        this._alreadyAlert = false;
        this._clicked = false;
        this._intervalId = window.setInterval(this._updateConnectionState.bind(undefined,this), 200);//後ろに引数を持ってくるのはIEに対応してないらしい
    }

    getInfo() {
        return {
            id: 'konashi5',
            name: Message.categoryName[this.setLocale()],

            menuIconURI: menuIconURI,
            blockIconURI: blockIconURI,

            color1: '#2A80B9',
            color2: '#1D587D',

            blocks: [{
                    opcode: 'connect',
                    blockType: BlockType.REPORTER,
                    text: Message.connect[this.setLocale()]
                },
                {
                    opcode: 'connectDone',
                    blockType: BlockType.HAT,
                    text: Message.done[this.setLocale()]
                },
                {
                    opcode: 'dataChanged',
                    blockType: BlockType.HAT,
                    text: Message.changed[this.setLocale()],
                    arguments: {
                        data: {
                            type: ArgumentType.BOOLEAN,
                            defaultValue: false
                        }
                    }
                },
                '---',
                {
                    opcode: 'setIO',
                    blockType: BlockType.COMMAND,
                    text: Message.setIO[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'pios',
                            defaultValue: 0
                        },
                        in_out: {
                            type: ArgumentType.NUMBER,
                            menu: 'inout',
                            defaultValue: 0
                        },
                    }
                },
                {
                    opcode: 'setPull',
                    blockType: BlockType.COMMAND,
                    text: Message.setPull[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'pios',
                            defaultValue: 0
                        },
                        pull: {
                            type: ArgumentType.NUMBER,
                            menu: 'pull',
                            defaultValue: 0
                        },
                    }
                },
                {
                    opcode: 'writeGpio',
                    blockType: BlockType.COMMAND,
                    text: Message.writeGpio[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'pios',
                            defaultValue: 1
                        },
                        high_low: {
                            type: ArgumentType.NUMBER,
                            menu: 'highlow',
                            defaultValue: 0
                        },
                    }
                },
                {
                    opcode: 'readGpio',
                    blockType: BlockType.REPORTER,
                    text: Message.readGpio[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'pios',
                            defaultValue: 1
                        },
                        io: {
                            type: ArgumentType.NUMBER,
                            menu: 'io',
                            defaultValue: 0
                        }
                    }
                },
                '---',
                {
                    opcode: 'setSoftPWM',
                    blockType: BlockType.COMMAND,
                    text: Message.setSoftPWM[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'softpwm',
                            defaultValue: 0
                        },
                        ctrlt: {
                            type: ArgumentType.NUMBER,
                            menu: 'ctrlt',
                            defaultValue: '1'
                        },
                        value: {
                            type:ArgumentType.NUMBER,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'outSoftPWM',
                    blockType: BlockType.COMMAND,
                    text: Message.outSoftPWM[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'softpwm',
                            defaultValue: 0
                        },
                        value: {
                            type:ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        trans: {
                            type:ArgumentType.NUMBER,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'readSoftPWM',
                    blockType: BlockType.REPORTER,
                    text: Message.readSoftPWM[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'softpwm',
                            defaultValue: 0
                        },
                        readtype: {
                            type: ArgumentType.NUMBER,
                            menu: 'pwmtype',
                            defaultValue: '0'
                        },
                    }
                },
                '---',
                {
                    opcode: 'setHardPwmPin',
                    blockType: BlockType.COMMAND,
                    text: Message.setHardPwmPin[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'hardpwm',
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'setHardPWM',
                    blockType: BlockType.COMMAND,
                    text: Message.setHardPWM[this.setLocale()],
                    arguments: {
                        clk: {
                            type: ArgumentType.NUMBER,
                            menu: 'clock',
                            defaultValue: 0
                        },
                        presc: {
                            type: ArgumentType.NUMBER,
                            menu: 'prescale',
                            defaultValue: 0
                        },
                        value: {
                            type:ArgumentType.NUMBER,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'outHardPWM',
                    blockType: BlockType.COMMAND,
                    text: Message.outHardPWM[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'hardpwm',
                            defaultValue: 0
                        },
                        value: {
                            type:ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        trans: {
                            type:ArgumentType.NUMBER,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'readHardPWM',
                    blockType: BlockType.REPORTER,
                    text: Message.readHardPWM[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'hardpwm',
                            defaultValue: '0'
                        },
                        readtype: {
                            type: ArgumentType.NUMBER,
                            menu: 'pwmtype',
                            defaultValue: '0'
                        },
                    }
                },
                '---',
                {
                    opcode: 'setAio0',
                    blockType: BlockType.COMMAND,
                    text: Message.setAio0[this.setLocale()],
                    arguments: {
                        in_out: {
                            type: ArgumentType.NUMBER,
                            menu: 'a0io',
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'setAio',
                    blockType: BlockType.COMMAND,
                    text: Message.setAio[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'a12',
                            defaultValue: '1'
                        },
                        in_out: {
                            type: ArgumentType.NUMBER,
                            menu: 'ainout',
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'setAdcPeri',
                    blockType: BlockType.COMMAND,
                    text: Message.adcPeriod[this.setLocale()],
                    arguments: {
                        peri: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'setAdcVref',
                    blockType: BlockType.COMMAND,
                    text: Message.adcVref[this.setLocale()],
                    arguments: {
                        ref: {
                            type: ArgumentType.NUMBER,
                            menu: 'adcVref',
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'setVdacVref',
                    blockType: BlockType.COMMAND,
                    text: Message.vdacVref[this.setLocale()],
                    arguments: {
                        ref: {
                            type: ArgumentType.NUMBER,
                            menu: 'vdacVref',
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'setIdacCran',
                    blockType: BlockType.COMMAND,
                    text: Message.idacCran[this.setLocale()],
                    arguments: {
                        range: {
                            type: ArgumentType.NUMBER,
                            menu: 'idacCran',
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'outAio0',
                    blockType: BlockType.COMMAND,
                    text: Message.outAio0[this.setLocale()],
                    arguments: {
                        ctrl: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        trans: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'outAio',
                    blockType: BlockType.COMMAND,
                    text: Message.outAio[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'a12',
                            defaultValue: '1'
                        },
                        ctrl: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        trans: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'inAio',
                    blockType: BlockType.REPORTER,
                    text: Message.readAio[this.setLocale()],
                    arguments: {
                        pin: {
                            type: ArgumentType.NUMBER,
                            menu: 'aio',
                            defaultValue: '0'
                        },
                        in_out: {
                            type: ArgumentType.NUMBER,
                            menu: 'io',
                            defaultValue: '0'
                        }
                    }
                },
                '---',
                {
                    opcode: 'setI2c',
                    blockType: BlockType.COMMAND,
                    text: Message.setI2c[this.setLocale()],
                    arguments: {
                        i2cmode: {
                            type: ArgumentType.NUMBER,
                            menu: 'i2ctype',
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'writeI2c',
                    blockType: BlockType.COMMAND,
                    text: Message.writeI2c[this.setLocale()],
                    arguments: {
                        addr: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00'
                        },
                        value: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00,0x00,0x00'
                        }
                    }
                },
                {
                    opcode: 'readI2c',
                    blockType: BlockType.COMMAND,
                    text: Message.readI2c[this.setLocale()],
                    arguments: {
                        addr: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00'
                        },
                        rlen: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'bothI2c',
                    blockType: BlockType.COMMAND,
                    text: Message.bothI2c[this.setLocale()],
                    arguments: {
                        addr: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00'
                        },
                        rlen: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        value: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00,0x00,0x00'
                        }
                    }
                },
                {
                    opcode: 'resultI2c',
                    blockType: BlockType.REPORTER,
                    text: Message.resultI2c[this.setLocale()]
                },
                '---',
                {
                    opcode: 'setUart',
                    blockType: BlockType.COMMAND,
                    text: Message.setUart[this.setLocale()],
                    arguments: {
                        baud: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        parity: {
                            type: ArgumentType.NUMBER,
                            menu: 'parity',
                            defaultValue: '0'
                        },
                        stopbit: {
                            type: ArgumentType.NUMBER,
                            menu: 'stopbit',
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'sendUart',
                    blockType: BlockType.COMMAND,
                    text: Message.sendUart[this.setLocale()],
                    arguments: {
                        value: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00,0x00'
                        }
                    }
                },
                {
                    opcode: 'readUart',
                    blockType: BlockType.REPORTER,
                    text: Message.readUart[this.setLocale()]
                },
                '---',
                {
                    opcode: 'setSpi',
                    blockType: BlockType.COMMAND,
                    text: Message.setSpi[this.setLocale()],
                    arguments: {
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        first: {
                            type: ArgumentType.NUMBER,
                            menu: 'order',
                            defaultValue: '0'
                        },
                        mode: {
                            type: ArgumentType.NUMBER,
                            menu: 'spimode',
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'writeSpi',
                    blockType: BlockType.COMMAND,
                    text: Message.writeSpi[this.setLocale()],
                    arguments: {
                        value: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00,0x00'
                        }
                    }
                },
                {
                    opcode: 'readSpi',
                    blockType: BlockType.REPORTER,
                    text: Message.readSpi[this.setLocale()]
                },
                '---',
                {
                    opcode: 'pres',
                    blockType: BlockType.REPORTER,
                    text: Message.pres[this.setLocale()]
                },
                {
                    opcode: 'temp',
                    blockType: BlockType.REPORTER,
                    text: Message.temp[this.setLocale()]
                },
                {
                    opcode: 'humi',
                    blockType: BlockType.REPORTER,
                    text: Message.humi[this.setLocale()]
                },
                {
                    opcode: 'detec',
                    blockType: BlockType.BOOLEAN,
                    text: Message.detec[this.setLocale()]
                },
                {
                    opcode: 'getAG',
                    blockType: BlockType.REPORTER,
                    text: Message.ag[this.setLocale()],
                    arguments: {
                        AorG: {
                            type: ArgumentType.NUMBER,
                            menu: 'AorG',
                            defaultValue: 0
                        },
                        xyz: {
                            type: ArgumentType.NUMBER,
                            menu: 'xyz',
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'setColor',
                    blockType: BlockType.COMMAND,
                    text: Message.setColor[this.setLocale()],
                    arguments: {
                        color: {
                            type: ArgumentType.NUMBER,
                            menu: 'color',
                            defaultValue: 0
                        },
                        bright: {
                            type:ArgumentType.NUMBER,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'outColorLED',
                    blockType: BlockType.COMMAND,
                    text: Message.outColorLED[this.setLocale()],
                    arguments: {
                        trans: {
                            type:ArgumentType.NUMBER,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'getColorLEDRed',
                    blockType: BlockType.REPORTER,
                    text: Message.getColorLEDRed[this.setLocale()]
                },
                {
                    opcode: 'getColorLEDGre',
                    blockType: BlockType.REPORTER,
                    text: Message.getColorLEDGre[this.setLocale()]
                },
                {
                    opcode: 'getColorLEDBlu',
                    blockType: BlockType.REPORTER,
                    text: Message.getColorLEDBlu[this.setLocale()]
                },
                {
                    opcode: 'getColorLEDA',
                    blockType: BlockType.REPORTER,
                    text: Message.getColorLEDA[this.setLocale()]
                },
                {
                    opcode: 'getColorLEDTra',
                    blockType: BlockType.REPORTER,
                    text: Message.getColorLEDTra[this.setLocale()]
                },
                '---',
                {
                    opcode: 'seqNum',
                    blockType: BlockType.REPORTER,
                    text: Message.seqNum[this.setLocale()],
                    arguments: {
                        data: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00,0x00'
                        },
                        num: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'seqDelAdd',
                    blockType: BlockType.REPORTER,
                    text: Message.seqDelAdd[this.setLocale()],
                    arguments: {
                        data: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00,0x00'
                        },
                        num: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '1'
                        },
                        del: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '0'
                        },
                        add: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00,0x00'
                        }
                    }
                },
                {
                    opcode: 'seqLen',
                    blockType: BlockType.REPORTER,
                    text: Message.seqLen[this.setLocale()],
                    arguments: {
                        data: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00,0x00'
                        }
                    }
                },
                {
                    opcode: 'byteTrans',
                    blockType: BlockType.REPORTER,
                    text: Message.byteTrans[this.setLocale()],
                    arguments: {
                        data: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00,0x00,0x00,0x00'
                        },
                        type: {
                            type: ArgumentType.NUMBER,
                            menu: 'uint',
                            defaultValue: '0'
                        },
                        endian: {
                            type: ArgumentType.NUMBER,
                            menu: 'endian',
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'byteCul',
                    blockType: BlockType.REPORTER,
                    text: Message.byteCul[this.setLocale()],
                    arguments: {
                        data: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00'
                        },
                        cul: {
                            type: ArgumentType.NUMBER,
                            menu: 'cul',
                            defaultValue: '0'
                        },
                        data2: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00'
                        }
                    }
                },
                {
                    opcode: 'bitCont',
                    blockType: BlockType.REPORTER,
                    text: Message.bitCont[this.setLocale()],
                    arguments: {
                        data: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00'
                        },
                        cont: {
                            type: ArgumentType.NUMBER,
                            menu: 'cont',
                            defaultValue: '0'
                        },
                        data2: {
                            type: ArgumentType.STRING,
                            defaultValue: '0x00'
                        }
                    }
                }
            ],
            menus: {
                pios: {
                    acceptReporters: true,
                    items: this.PIO_MENU
                },
                inout: {
                    acceptReporters: true,
                    items: this.IO_MENU
                },
                pull:{
                    acceptReporters:true,
                    items:this.PULL_MENU
                },
                highlow: {
                    acceptReporters: true,
                    items: this.HIGH_LOW_MENU
                },
                io: {
                    acceptReporters: true,
                    items: this.INOUT_MENU
                },
                softpwm: {
                    acceptReporters: true,
                    items: this.SOFT_PWM_MENU
                },
                hardpwm: {
                    acceptReporters: true,
                    items: this.HARD_PWM_MENU
                },
                ctrlt: {
                    acceptReporters: true,
                    items: this.CTRLT_MENU
                },
                clock: {
                    acceptReporters: true,
                    items: this.CLK_MENU
                },
                prescale: {
                    acceptReporters: true,
                    items: this.PRESC_MENU
                },
                pwmtype: {
                    acceptReporters: true,
                    items: this.PWMTYPE_MENU
                },
                a0io: {
                    acceptReporters: true,
                    items: this.A0IO_MENU
                },
                a12: {
                    acceptReporters: true,
                    items: this.ONE2_MENU
                },
                aio: {
                    acceptReporters: true,
                    items: this.AIO_MENU
                },
                ainout: {
                    acceptReporters: true,
                    items: this.AINOUT_MENU
                },
                adcVref: {
                    acceptReporters: true,
                    items: this.ADC_MENU
                },
                vdacVref: {
                    acceptReporters: true,
                    items: this.VDAC_MENU
                },
                idacCran: {
                    acceptReporters: true,
                    items: this.IDAC_MENU
                },
                i2ctype: {
                    acceptReporters: true,
                    items: this.I2CMODE_MENU
                },
                parity: {
                    acceptReporters: true,
                    items: this.PARITY_MENU
                },
                stopbit: {
                    acceptReporters: true,
                    items: this.STOPBIT_MENU
                },
                order: {
                    acceptReporters: true,
                    items: this.ORDER_MENU
                },
                spimode: {
                    acceptReporters: true,
                    items: this.SPIMODE_MENU
                },
                ZEROorONE: {
                    acceptReporters: true,
                    items: this.ZERO1_MENU
                },
                AorG: {
                    acceptReporters: true,
                    items: this.AG_MENU
                },
                xyz: {
                    acceptReporters: true,
                    items: this.XYZ_MENU
                },
                color:{
                    acceptReporters: true,
                    items: this.COLOR_MENU
                },
                uint:{
                    acceptReporters: true,
                    items: this.UINT_MENU
                },
                endian:{
                    acceptReporters: true,
                    items: this.ENDI_MENU
                },
                cont:{
                    acceptReporters: true,
                    items: this.CONT_MENU
                },
                cul:{
                    acceptReporters: true,
                    items: this.CUL_MENU
                }
            }
        };
    }

    _updateConnectionState(that) {//that = thisじゃダメだた
        // player-only pages (play/player.html) have no Blockly workspace: the flyout
        // checkbox polled below only exists in the editor.
        const workspace = Blockly.getMainWorkspace();
        if (!workspace) return;

        const targetBlock = workspace.getBlockById('konashi5_connect');
        if (targetBlock) {
            that._clicked = targetBlock.flyoutCheckbox.clicked;
        }

        // { first action

        if (that._connectionState == ConnectionState.NONE) {
            if (that._clicked) {
                that._kokoroPro.connect().catch((error) => {
                    log.log(error);
                    that._connectionState = ConnectionState.NOT_FOUND; // finish first act
                });

                that._connectionState = ConnectionState.TRY;
            }
        }

        if (that._connectionState == ConnectionState.TRY) {
            if (that._kokoroPro.conDone) {
            //if (that._kokoroPro.isConnected()) {
                that._connectionState = ConnectionState.CONNECTED; // finish first act
            }

            if (that._kokoroPro.isConnectionFailed()) {
                that._connectionState = ConnectionState.LOST;
            }
        }

        if (that._connectionState == ConnectionState.CONNECTED) {
            // Unchecked connect button. second act
            if (!that._clicked) {
                that._connectionState = ConnectionState.DISCONNECTING; // finish second act
            }

            // when konashi lost (e.g. power down, took usb cables.)
            if (!that._kokoroPro.isConnected()) {
                that._connectionState = ConnectionState.LOST; // finish first act
            }
        }

        // first act}

        // { third act

        if (that._connectionState == ConnectionState.NOT_FOUND) {
            if (!that._alreadyAlert) {
                alert(Message.lost_alert[that.setLocale()]);
                that._alreadyAlert = true;
            }

            if (!that._clicked) {
                that._reset();
            }
        }

        if (that._connectionState == ConnectionState.LOST) {
            if (!that._alreadyAlert) {
                alert(Message.disconnect_alert[that.setLocale()]);
                that._alreadyAlert = true;
            }

            if (!that._clicked) {
                that._reset();
            }
        }

        // チェックボックスが外された
        if (that._connectionState == ConnectionState.DISCONNECTING) {
            that._reset();
        }
        // third act }
    }

    /**
     * 
     * @param {Boolean} alreadyConnected
     * @private
     */
    _reset() {
        const that=this

        if (this._kokoroPro.isConnected()){
            that._kokoroPro._konashi.readConf()
            .then(v=>{
                const data=[];
                for (let i=0;i<8;i++){
                  data[i]= v.getUint8(i*2);
                }
                return data;
            })
            .then(v=>{
                return that._kokoroPro._reset(v);
            }).catch(e=>console.log(e))
            .then(()=>{
                return that._kokoroPro._removeevent();
            }).catch(e=>console.log(e))
            .finally(()=>{
                this._kokoroPro = new KokoroPro();
                this._alreadyAlert = false;
                this._connectionState = ConnectionState.NONE;
            });
        }else{
            this._kokoroPro = new KokoroPro();
            this._alreadyAlert = false;
            this._connectionState = ConnectionState.NONE;
        };
    }

    /**
     * @return {array} - text and values for each buttons pin number element
     */
    get PIO_MENU() {
        let menu = [],m;
        for (let i = 0;i<8;i++){
            m = {text: '' + i + '',value:'' + i + ''};//数字だとブロックが動かなくなる
            menu.push(m);
        }
        return menu;
    }

    get IO_MENU() {
        return [{
                text: Message.input[this.setLocale()],
                value: '0'
            },
            {
                text: Message.output[this.setLocale()],
                value: '1'
            },
            {
                text: Message.openD[this.setLocale()],
                value: '2'
            },
            {
                text: Message.openS[this.setLocale()],
                value: '3'
            },
        ]
    }

    get PULL_MENU() {
        return [{
                text: Message.pullN[this.setLocale()],
                value: '0'
            },
            {
                text: Message.pullU[this.setLocale()],
                value: '1'
            },
            {
                text: Message.pullD[this.setLocale()],
                value: '2'
            }
        ]
    }

    get HIGH_LOW_MENU() {
        return [{
                text: 'LOW',
                value: '0'
            },
            {
                text: 'HIGH',
                value: '1'
            },
            {
                text: Message.toggle[this.setLocale()],
                value: '2'
            }
        ]
    }

    get INOUT_MENU() {
        return [{
                text: Message.input[this.setLocale()],
                value: '0'
            },
            {
                text: Message.output[this.setLocale()],
                value: '1'
            }
        ]
    }

    get SOFT_PWM_MENU() {
        return [{
                text: '0 (GPIO4)', value: '0'
            },
            {
                text: '1 (GPIO5)', value: '1'
            },
            {
                text: '2 (GPIO6)', value: '2'
            },
            {
                text: '3 (GPIO7)', value: '3'
            },
        ];
    }

    get HARD_PWM_MENU() {
        return [{
                text: '0 (GPIO0)', value: '0'
            },
            {
                text: '1 (GPIO1)', value: '1'
            },
            {
                text: '2 (GPIO2)', value: '2'
            },
            {
                text: '3 (GPIO3)', value: '3'
            },
        ];
    }

    get CTRLT_MENU() {
        return [{
                text: Message.duty[this.setLocale()],
                value: '0'
            },
            {
                text: Message.period[this.setLocale()],
                value: '1'
            }
        ]
    }

    get CLK_MENU() {
        return [{
                text: '38.4M',
                value: '0'
            },
            {
                text: '20k',
                value: '1'
            }
        ]
    }

    get PRESC_MENU() {
        let menu = [],m;
        for (let i = 0;i<11;i++){
            m = {text: '' + 2**i + '',value:'' + i + ''};//数字だとブロックが動かなくなる
            menu.push(m);
        }
        return menu;
    }

    get PWMTYPE_MENU() {
        return [{
                text: Message.value[this.setLocale()],
                value: '0'
            },
            {
                text: Message.trans[this.setLocale()],
                value: '1'
            }
        ]
    }

    get A0IO_MENU() {
        return [{
                text: "ADC" + Message.input[this.setLocale()],
                value: '0'
            },
            {
                text: "IDAC" + Message.output[this.setLocale()],
                value: '1'
            }
        ]
    }

    get ONE2_MENU() {
        let menu = [],m;
        for (let i = 1;i<3;i++){
            m = {text: '' + i + '',value:'' + i + ''};//数字だとブロックが動かなくなる
            menu.push(m);
        }
        return menu;
    }

    get AINOUT_MENU() {
        return [{
                text: "ADC" + Message.input[this.setLocale()],
                value: '0'
            },
            {
                text: "VDAC" + Message.output[this.setLocale()],
                value: '1'
            }
        ]
    }

    get ADC_MENU() {
        return [{
                text: Message.disable[this.setLocale()],
                value: '0'
            },
            {
                text: "1.25V",
                value: '1'
            },
            {
                text: "2.5V",
                value: '2'
            },
            {
                text: "VDD",
                value: '3'
            }
        ]
    }

    get VDAC_MENU() {
        return [{
                text: Message.disable[this.setLocale()],
                value: '0'
            },
            {
                text: "1.25V " + Message.lowNoise[this.setLocale()],
                value: '1'
            },
            {
                text: "2.5V " + Message.lowNoise[this.setLocale()],
                value: '2'
            },
            {
                text: "1.25V ",
                value: '3'
            },
            {
                text: "2.5V",
                value: '4'
            },
            {
                text: "AVDD",
                value: '5'
            }
        ]
    }

    get IDAC_MENU() {
        return [{
                text: Message.disable[this.setLocale()],
                value: '0'
            },
            {
                text: "0.05~1.6uA, 50nA" + Message.step[this.setLocale()],
                value: '1'
            },
            {
                text: "1.6~4.7uA, 100nA" + Message.step[this.setLocale()],
                value: '2'
            },
            {
                text: "0.5~16uA, 500nA" + Message.step[this.setLocale()],
                value: '3'
            },
            {
                text: "2~64uA, 2000nA" + Message.step[this.setLocale()],
                value: '4'
            },
        ]
    }

    get AIO_MENU() {
        let menu = [],m;
        for (let i = 0;i<3;i++){
            m = {text: '' + i + '',value:'' + i + ''};//数字だとブロックが動かなくなる
            menu.push(m);
        }
        return menu;
    }

    get I2CMODE_MENU() {
        return [{
                text: Message.standard[this.setLocale()],
                value: '0'
            },
            {
                text: Message.fast[this.setLocale()],
                value: '1'
            }
        ]
    }

    get PARITY_MENU() {
        return [{
                text: 'NO',
                value: '0'
            },
            {
                text: 'ODD',
                value: '1'
            },
            {
                text: 'EVEN',
                value: '2'
            }
        ]
    }

    get STOPBIT_MENU() {
        return [{
                text: '0.5',
                value: '0'
            },
            {
                text: '1',
                value: '1'
            },
            {
                text: '1.5',
                value: '2'
            },
            {
                text: '2',
                value: '3'
            }
        ]
    }

    get ORDER_MENU() {
        return [{
                text: 'LSB',
                value: '0'
            },
            {
                text: 'MSB',
                value: '1'
            }
        ]
    }

    get SPIMODE_MENU() {
        return [{
                text: '0',
                value: '0'
            },
            {
                text: '1',
                value: '1'
            },
            {
                text: '2',
                value: '2'
            },
            {
                text: '3',
                value: '3'
            }
        ]
    }

    get ZERO1_MENU() {
        let menu = [],m;
        for (let i = 0;i<2;i++){
            m = {text: '' + i + '',value:'' + i + ''};//数字だとブロックが動かなくなる
            menu.push(m);
        }
        return menu;
    }

    get AG_MENU() {
        return [{
            text: Message.accel[this.setLocale()],
            value: '0'
            },
            {
            text: Message.gylo[this.setLocale()],
            value: '1'
            }
        ]
    }

    get XYZ_MENU() {
        return [{
            text: 'X',
            value: '0'
            },
            {
            text: 'Y',
            value: '1'
            },
            {
            text: 'Z',
            value: '2'
            }
        ]
    }

    /**
     * @return {array} - text and values for each buttons pin number element
     */
    get COLOR_MENU() {
        return [{
                text: Message.Red[this.setLocale()],
                value: '0'
            },
            {
                text: Message.Green[this.setLocale()],
                value: '1'
            },
            {
                text: Message.Blue[this.setLocale()],
                value: '2'
            },
            {
                text: Message.Alpha[this.setLocale()],
                value: '3'
            }
        ]
    }

    get UINT_MENU() {
        return [{
            text: 'Int',
            value: '0'
            },
            {
            text: 'Uint',
            value: '1'
            }
        ]
    }

    get ENDI_MENU() {
        return [{
            text: 'little',
            value: '0'
            },
            {
            text: 'big',
            value: '1'
            }
        ]
    }

    get CUL_MENU() {
        return [{
                text: '+',
                value: '0'
            },
            {
                text: '-',
                value: '1'
            },
            {
                text: '×',
                value: '2'
            },
            {
                text: '÷',
                value: '3'
            },
            {
                text: 'mod',
                value: '4'
            }
        ]
    }

    get CONT_MENU() {
        return [{
                text: '<<',
                value: '0'
            },
            {
                text: '>>',
                value: '1'
            },
            {
                text: '&',
                value: '2'
            },
            {
                text: '|',
                value: '3'
            },
            {
                text: '^',
                value: '4'
            }
        ]
    }

    connect() {
        if (this._connectionState == ConnectionState.NONE) {
            return Message.connectionState.none[this.setLocale()];
        }

        if (this._connectionState == ConnectionState.NOT_FOUND) {
            return Message.connectionState.not_found[this.setLocale()];
        }

        if (this._connectionState == ConnectionState.TRY) {
            return Message.connectionState.try[this.setLocale()];
        }

        if (this._connectionState == ConnectionState.CONNECTED) {
            return Message.connectionState.connected[this.setLocale()];
        }

        if (this._connectionState == ConnectionState.DISCONNECTING) {
            return Message.connectionState.disconnecting[this.setLocale()];
        }

        if (this._connectionState == ConnectionState.LOST) {
            return Message.connectionState.lost[this.setLocale()];
        }

        return 'ERROR';
    }

    connectDone() {
        return this._kokoroPro.conDone;
    }

    setIO(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setIO(parseInt(args.pin), parseInt(args.in_out));
    }

    setPull(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setPull(parseInt(args.pin),parseInt(args.pull))
    }

    writeGpio(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.writeGpio(parseInt(args.pin), parseInt(args.high_low));
    }

    readGpio(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.readGpio(parseInt(args.pin),parseInt(args.io))
    }

    setSoftPWM(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setSoftPWM(parseInt(args.pin),parseInt(args.ctrlt)+1,parseInt(args.value))
    }

    outSoftPWM(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.outSoftPWM(parseInt(args.pin),parseInt(args.value),parseInt(args.trans))
    }

    readSoftPWM(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.readSoftPWM(parseInt(args.pin),parseInt(args.readtype))
    }

    setHardPwmPin(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setHardPwmPin(parseInt(args.pin));
    }

    setHardPWM(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setHardPWM(parseInt(args.clk),parseInt(args.presc),parseInt(args.value))
    }

    outHardPWM(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.outHardPWM(parseInt(args.pin),parseInt(args.value),parseInt(args.trans))
    }

    readHardPWM(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.readHardPWM(parseInt(args.pin),parseInt(args.readtype))
    }

    setAio0(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setAio(0,parseInt(args.in_out))
    }

    setAio(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setAio(parseInt(args.pin),parseInt(args.in_out))
    }

    setAdcPeri(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setAdcPeri(parseInt(args.peri));
    }

    setAdcVref(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setAnaConf(1,parseInt(args.ref))
    }

    setVdacVref(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setAnaConf(2,parseInt(args.ref))
    }

    outAio0(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.outAio(0,parseInt(args.ctrl),parseInt(args.trans));
    }

    outAio(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.outAio(parseInt(args.pin),parseInt(args.ctrl),parseInt(args.trans));
    }

    inAio(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.readAio(parseInt(args.pin),parseInt(args.in_out));
    }

    setIdacCran(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setAnaConf(3,parseInt(args.range))
    }

    setI2c(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setI2c(parseInt(args.i2cmode))
    }

    writeI2c(args) {
        if (!this._kokoroPro.isConnected()) return;
        let val = args.value.split(',').map(str => parseInt(str));
        return this._kokoroPro.useI2c(0,0,parseInt(args.addr),val)
    }

    readI2c(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.useI2c(1,parseInt(args.rlen),parseInt(args.addr),null)
    }

    bothI2c(args) {
        if(!this._kokoroPro.isConnected()) return;
        let val = args.value.split(',').map(str => parseInt(str));
        return this._kokoroPro.useI2c(2,parseInt(args.rlen),parseInt(args.addr),val)
    }

    resultI2c() {
        return this._kokoroPro.i2c[3];
    }

    setUart(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setUart(parseInt(args.parity),parseInt(args.stopbit),parseInt(args.baud))
    }

    sendUart(args) {
        if (!this._kokoroPro.isConnected()) return;
        let val = args.value.split(',').map(str => parseInt(str));
        return this._kokoroPro.sendUart(args.value);
    }

    readUart() {
        return this._kokoroPro.uartData;
    }

    setSpi(args) {
        if (!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setSpi(parseInt(args.first),parseInt(args.mode),parseInt(args.speed))
    }

    writeSpi(args) {
        if (!this._kokoroPro.isConnected()) return;
        let val = args.value.split(',').map(str => parseInt(str));
        return this._kokoroPro.writeSpi(val);
    }

    readSpi() {
        return this._kokoroPro.spiData;
    }

    pres(){
        return this._kokoroPro._buildIn[0];
    }

    temp(){
        return this._kokoroPro._buildIn[1];
    }
    
    humi(){
        return this._kokoroPro._buildIn[2];
    }

    detec(){
        return this._kokoroPro._buildIn[3];
    }

    getAG(args){
        return this._kokoroPro.getAG(parseInt(args.AorG),parseInt(args.xyz));
    }

    setColor(args){
        if(!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.setColorLED(parseInt(args.color), parseInt(args.bright));
    }

    outColorLED(args){
        if(!this._kokoroPro.isConnected()) return;
        return this._kokoroPro.outColorLED(parseInt(args.trans));
    }

    getColorLEDRed(){
        return this._kokoroPro._colors[0];
    }

    getColorLEDGre(){
        return this._kokoroPro._colors[1];
    }

    getColorLEDBlu(){
        return this._kokoroPro._colors[2];
    }

    getColorLEDA(){
        return this._kokoroPro._colors[3];
    }

    getColorLEDTra(){
        return this._kokoroPro._colors[4];
    }

    dataChanged(args){
        return args.data;
    }

    seqNum(args){
        let val = args.data.split(',');
        return val[parseInt(args.num)-1];
    }

    /**
     * 特定箇所のデータを削除，追加する．
     * 
     * @returns 
     */
    seqDelAdd(args){
        let val = args.data.split(',');
        let add = args.add.split(',');
        if (add != ''){
            val.splice(parseInt(args.num)-1,parseInt(args.del),add);
        }else{
            val.splice(parseInt(args.num)-1,parseInt(args.del));
        }
        val = val.flat();
        let value = "" + val[0];
        for (let l=1;l<val.length;l++){
            value = value + ',' + val[l];
        }
        return value;
    }

    /**
     * データの数(コンマ区切り)を返す．
     * 
     * @returns Number
     */
    seqLen(args){
        let val = args.data.split(',');
        return val.length;
    }

    /** 
     * 16進数を10進数にする．
     * int16でマイナスの処理：2進数に変換して配列化．各桁に0→1，1→0を実行．+1してpaeseInt後-をつけて返す．
     * 
     * @returns Number
     */
    byteTrans(args){
        let val = args.data.split('0x').join('');
        let resu = val.split(',').map(str => ('00' + str).slice(-2));
        if (args.endian == '0'){
            val = resu.reverse().join('');
        }else{
            val = resu.join('');
        }
        console.log(val);
        if (args.type == '0' && parseInt(val,16).toString(2).length == val.length*4){//int指定で先頭が1(マイナスになるとき)
            val = parseInt(val,16).toString(2);
            console.log(val);
            resu = val.split('').map(str => parseInt(str));
            for(let l=0;l<resu.length;l++){
                if(resu[l] == 0){
                    resu[l] = 1
                }else{
                    resu[l] = 0
                }
            }
            val = resu.join('');
            val = - (parseInt(val,2) + 1)
        }
        val = parseInt(val,16);
        return val;
    }

    /**
     * 和差積商，余りの計算
     * @returns Number or String
     */
    byteCul(args){
        let resul = 0;
        let kazu = args.data.split(',0x').join('');
        let kazu2 = args.data2.split(',0x').join('');
        if (args.cul == '0'){
            resul = parseInt(kazu) + parseInt(kazu2);
        }else if (args.cul == '1'){
            resul = parseInt(kazu) - parseInt(kazu2);
            return resul;//16進数にせずに返す
        }else if (args.cul == '2'){
            resul = parseInt(kazu) * parseInt(kazu2);
        }else if (args.cul == '3'){
            resul = parseInt(kazu) / parseInt(kazu2) | 0;
        }else if (args.cul == '4'){
            resul = parseInt(kazu) % parseInt(kazu2);
        }
        if (args.data.indexOf('0x') != -1 || args.data2.indexOf('0x') != -1){ //もし16進数で入力されていたら16進数にする
            let resu = [];
            resul = resul.toString(16);
            if (resul.length % 2 == 1){ //奇数桁を偶数にする
                resul = '0'+ resul;
            }
            for (let l=0;l<resul.length-1;l+=2){ //2桁ずつ16進数にし，配列化
                resu.push('0x'+resul[l]+resul[l+1]);
            }
            return resu.join(',');
        }
        return resul;
    }

    /**
     * シフト，ビット演算
     * @returns Number or String (基本16進数での使用なので基本Stringで返す)
     */
    bitCont(args){
        let resul = 0;
        let kazu = args.data.split(',0x').join('');
        let kazu2 = args.data2.split(',0x').join('');
        if (args.cont == '0'){
            resul = parseInt(kazu) * (2 ** parseInt(kazu2)); // kazu << kazu2
        }else if (args.cont == '1'){
            resul = parseInt(kazu) >> parseInt(kazu2);
        }else if (args.cont == '2'){
            resul = parseInt(kazu) & parseInt(kazu2);
        }else if (args.cont == '3'){
            resul = parseInt(kazu) | parseInt(kazu2);
        }else if (args.cont == '4'){
            resul = parseInt(kazu) ^ parseInt(kazu2);
        }
        if (resul<0)resul=-resul;
        if (args.data.indexOf('0x') != -1 || args.data2.indexOf('0x') != -1){
            let resu = [];
            resul = resul.toString(16);
            if (resul.length % 2 == 1){ //奇数桁を偶数にする
                resul = '0'+ resul;
            }
            for (let l=0;l<resul.length-1;l+=2){ //2桁ずつ16進数にし，配列化
                resu.push('0x'+resul[l]+resul[l+1]);
            }
            return resu.join(',');
        };
        return resul;
    }

    setLocale() {
        let locale = formatMessage.setup().locale;
        if (AvailableLocales.includes(locale)) {
            return locale;
        } else {
            return 'en';
        }
    }
}

module.exports = KonashiBlocks;
